export interface AppVersionInfo {
  buildTime: string;
}

export async function fetchDeployedBuildTime(): Promise<string | null> {
  try {
    const response = await fetch('/version.json', { cache: 'no-store' });
    if (!response.ok) {
      return null;
    }
    const data = (await response.json()) as AppVersionInfo;
    return typeof data.buildTime === 'string' ? data.buildTime : null;
  } catch {
    return null;
  }
}

export function isNewerBuildDeployed(
  localBuildTime: string,
  remoteBuildTime: string
): boolean {
  return remoteBuildTime !== localBuildTime;
}

export async function triggerServiceWorkerUpdate(): Promise<void> {
  if (!navigator.serviceWorker) {
    return;
  }
  const registration = await navigator.serviceWorker.getRegistration();
  if (registration) {
    await registration.update();
  }
}
